document.addEventListener('DOMContentLoaded', function () {
    const jsReviewBody = document.querySelectorAll('.jsReviewBody');

    for (let index = 0; index < jsReviewBody.length; index++) {
        let body = jsReviewBody[index];
        let content = body.querySelector('.jsReviewContent');
        let button = body.querySelector('.jsReviewMore');
        
        if(body.offsetHeight < content.offsetHeight) {
            button.classList.add('is-visible')
        } else {
            button.classList.remove('is-visible')
        }

        button.addEventListener('click', () => {
            body.classList.toggle('is-active');
            
            if(body.classList.contains('is-active')){
                body.style.maxHeight = content.offsetHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }
        })
    }
})

